import buttonStyle from "./button.style";
import formLabelStyle from "./form-label.style";
import headingStyle from "./heading.style";
import inputStyle from "./input.style";
import selectStyle from "./select.style";
import textStyle from "./text.style";
import { tooltipStyle } from "./tooltip";

export const components = {
  Heading: headingStyle,
  Text: textStyle,
  FormLabel: formLabelStyle,
  Button: buttonStyle,
  Input: inputStyle,
  Select: selectStyle,
  Tooltip: tooltipStyle,
};
